export default "__VITE_ASSET__CjylPXWD__"